@if (announcement()?.message) {
<div [style.background-color]="announcement()!.background_color" class="announcement-bar-wrapper">
  <p [style.color]="announcement()!.text_color">{{ announcement()!.message }}</p>
</div>
}
